module.exports = __webpack_public_path__ + "img/airplane.fc044bc0.png";